import React, { useState } from 'react';
import { ConfirmDialog } from './FormControls';

interface Question {
  title: string;
  message: React.ReactNode;
  confirmLabel: string;
}

// Asks before something that cannot be taken back: `ask(question, action)` opens the dialog and
// runs the action only on confirming. Render `dialog` once in the component.
export const useConfirm = (): [(question: Question, action: () => void) => void, React.ReactElement] => {
  const [pending, setPending] = useState<(Question & { action: () => void }) | null>(null);
  const dialog = (
    <ConfirmDialog
      isOpen={!!pending}
      onClose={() => setPending(null)}
      onConfirm={() => {
        pending?.action();
        setPending(null);
      }}
      title={pending?.title ?? ''}
      message={pending?.message ?? ''}
      confirmLabel={pending?.confirmLabel ?? 'Delete'}
    />
  );
  return [(question, action) => setPending({ ...question, action }), dialog];
};
